import { createContext, useContext, useMemo, useState } from "react"
const ContextsQuestion = createContext()

/**
 * Proveedor de contexto para el plan anual.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 */
export function ContextsQuestionProvider({ children }) {
	const [reload, setReload] = useState(true)
	const [questionId, setQuestionId] = useState(null)
	const [question, setQuestion] = useState(null)
	const [open, setOpen] = useState(false)
	const [info, setInfo] = useState(false)
	const datos = useMemo(
		() => ({
			reload,
			refresh: () => setReload(!reload),
			question,
			setQuestion,
			open,
			setOpen,
			info,
			setInfo,
			questionId,
			setQuestionId,
		}),
		[info, open, question, questionId, reload]
	)
	return <ContextsQuestion.Provider value={datos}>{children}</ContextsQuestion.Provider>
}

/**
 * @typedef {Object} QuestionContextParams
 * @property {boolean} reload
 * @property {function():void} refresh - actualiza el reload
 * @property {Question|null} question
 * @property {function():void} setQuestion
 * @property {int} questionId
 * @property {function(int):void} setQuestionId
 * @property {boolean } open
 * @property {(value: boolean) => void} setOpen
 * @property {boolean } info
 * @property {(value: boolean) => void} setInfo
 */

/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {QuestionContextParams}
 */

export function UseContextsQuestion() {
	return useContext(ContextsQuestion)
}
